/**
 * Wixtar 派券預設通知格式的預覽內容
 *
 * ⚠️ 此檔案僅供 Admin 畫面預覽，實際推播內容由後端
 *    api/src/integrations/wixtar/utils/wixtarTicketFlexMessage.js 產生。
 *    修改版面時務必同步兩邊，否則預覽會與會員實際收到的訊息不符。
 */

/** 預覽用的按鈕連結；實際推播會換成該 LINE 官方帳號的 LIFF 網址 */
const PREVIEW_LIFF_URL = 'https://liff.line.me/';

/**
 * @param {Object} ticket - 票券資料
 * @param {string|null} [ticket.ticketName] - 票券名稱
 * @param {string|null} [ticket.activitySubject] - 所屬活動名稱
 * @returns {Object} LineMessagePreview 的 flexContent（bubble）
 */
export function buildWixtarTicketDefaultBubble({ ticketName, activitySubject } = {}) {
  const displayName = ticketName || '票券';

  const detailRows = [];

  if (activitySubject) {
    detailRows.push({
      type: 'box',
      layout: 'horizontal',
      contents: [
        { type: 'text', text: '活動', size: 'sm', color: '#888888', flex: 2 },
        { type: 'text', text: activitySubject, size: 'sm', flex: 3, wrap: true, color: '#333333' }
      ]
    });
  }

  detailRows.push({
    type: 'text',
    text: '票券已存入您的會員票券夾，點下方按鈕即可查看。',
    size: 'sm',
    color: '#888888',
    wrap: true
  });

  return {
    type: 'bubble',
    header: {
      type: 'box',
      layout: 'vertical',
      backgroundColor: '#00B900',
      paddingAll: '16px',
      contents: [
        {
          type: 'text',
          text: '您收到了一張票券！',
          color: '#ffffff',
          size: 'md',
          weight: 'bold'
        }
      ]
    },
    body: {
      type: 'box',
      layout: 'vertical',
      spacing: 'md',
      paddingAll: '16px',
      contents: [
        {
          type: 'text',
          text: displayName,
          size: 'lg',
          weight: 'bold',
          wrap: true,
          color: '#1a1a1a'
        },
        { type: 'separator', margin: 'md' },
        {
          type: 'box',
          layout: 'vertical',
          spacing: 'sm',
          margin: 'md',
          contents: detailRows
        }
      ]
    },
    footer: {
      type: 'box',
      layout: 'vertical',
      spacing: 'none',
      contents: [
        {
          type: 'button',
          style: 'primary',
          color: '#00B900',
          height: 'sm',
          action: {
            type: 'uri',
            label: '查看我的票券',
            uri: PREVIEW_LIFF_URL
          }
        }
      ]
    }
  };
}
